// ============================================================================
// FNE-BRIDGE Frontend - Configuration environnement
// ============================================================================

// URL API : toujours relative — fonctionne partout :
//   Dev (Vite proxy) : http://localhost:5173/api/v1 → proxy → http://127.0.0.1:3001
//   LAN (build statique) : http://192.168.x.x:3001/api/v1 → même serveur Express
const API_BASE = import.meta.env.VITE_API_BASE_URL || '/api/v1';

export const env = {
  // API
  apiBaseUrl: API_BASE,
  apiTimeout: Number(import.meta.env.VITE_API_TIMEOUT) || 30000,

  // App
  appName: import.meta.env.VITE_APP_NAME || 'FNE-Bridge',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
  appEnv: import.meta.env.VITE_APP_ENV || 'development',

  // Auth
  tokenRefreshThreshold: 60, // secondes avant expiration pour refresh
  sessionTimeout: 30 * 60 * 1000, // 30 minutes en ms

  // Pagination
  defaultPageSize: 20,
  maxPageSize: 100,

  // Upload
  maxFileSize: 10 * 1024 * 1024, // 10MB

  // Feature flags
  enableDarkMode: import.meta.env.VITE_ENABLE_DARK_MODE === 'true',
  enableI18n: import.meta.env.VITE_ENABLE_I18N === 'true',

  // Debug
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;
